import { TFunction } from "i18next";
import { ProcessedNotication } from "./utils";
import { formatDistanceToNow, Locale } from "date-fns";
import { cn } from "@/lib/utils";
import { ToolBarButton } from "./NotificationCenter";
import { Notification } from "@/graphql/__generated__/graphql";
import { ArrowRight } from "lucide-react";

/**
 * NotificationCard component to display a single notification
 */
interface NotificationCardProps {
  notification: Notification;
  processedNotification: ProcessedNotication;
  handleViewClick: (_notification: Notification) => void;
  handleMarkAsRead?: (_notification: Notification) => void;
  currentLocale: Locale;
  t: TFunction;
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  notification,
  processedNotification,
  handleViewClick,
  handleMarkAsRead,
  currentLocale,
  t
}: NotificationCardProps) => {
  return (
    <div
      onClick={() => handleViewClick(notification)}
      className="flex flex-row pr-2 rounded-md transition-all py-2 duration-200 ease-linear mb-2 hover:bg-gray-100 cursor-pointer"
    >
      <div className={cn("w-[3px]", notification.isActionRequired ? "bg-orange-200" : "bg-blue-200")}></div>
      <div className="gap-2 flex-1 pl-2">
        <div className="flex items-center gap-2">
          <div className="overflow-hidden pr-1 flex-1">
            <p className="text-sm font-semibold overflow-hidden text-ellipsis wrap-break-word hyphens-auto">
              {processedNotification.title}
            </p>
            <p
              className="text-xs text-gray-500 overflow-hidden text-ellipsis wrap-break-word hyphens-auto select-text"
              style={{overflowWrap: "anywhere"}}
            >
              {processedNotification.message}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-between mt-1">
          <p className="text-xs text-gray-400 break-before-auto">
            {formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true, locale: currentLocale })}
          </p>
          <div className="flex items-center gap-2">
            {handleMarkAsRead ? (
              <ToolBarButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleMarkAsRead(notification);
                }}
                title={t("notificationcenter.buttons.markasread")}
                disabled={false}
              />
            ) : notification.isActionRequired ? (
              <ArrowRight className="h-4 w-4 text-gray-400" />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;
